import { useSelector } from '@hh.ru/front-static-app';
import { Button } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { formatToReactComponent } from 'bloko/common/trl';

import { useGeoFiltersAnalytics } from 'src/components/Search/Resume/Filters/Geo/hooks/useAnalytics';
import translation from 'src/components/translation';
import { EMPTY_CLUSTER } from 'src/models/search/common/clusters';
import { ClusterKey, TypeByClusterKey } from 'src/types/search/common/clusters';

import styles from './styles.less';

const HHTM_SOURCE_LABEL = 'search_filters_form';

const TrlKeys = {
    allRegions: 'search.resume.filters.geo.areaButton.allRegions',
    regionPostfix: 'search.resume.filters.geo.areaButton.regionPostfix',
};

const AreaButton: TranslatedComponent<{ onClick: () => void }> = ({ onClick, trls }) => {
    const { groups, selectedValues } =
        useSelector((state) => state.searchClusters[ClusterKey.Area]) ||
        (EMPTY_CLUSTER as TypeByClusterKey<typeof ClusterKey.Area>);

    const buttonTrl = selectedValues.length > 0 ? groups[selectedValues[0].toString()].title : trls[TrlKeys.allRegions];
    const postfixTrl =
        selectedValues.length > 1
            ? formatToReactComponent(trls[TrlKeys.regionPostfix], {
                  '{0}': selectedValues.length - 1,
              })
            : undefined;

    const { sendEventGeoDraftOpen } = useGeoFiltersAnalytics();

    return (
        <div
            className={styles.triggerWrapper}
            onClick={() => {
                onClick();
                sendEventGeoDraftOpen(HHTM_SOURCE_LABEL);
            }}
            data-qa="geo-search-trigger"
        >
            <Button stretched size="small" mode="primary" style="contrast" postfix={postfixTrl}>
                {buttonTrl}
            </Button>
        </div>
    );
};

export default translation(AreaButton);
